// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"86":"bd946a88","550":"13a2362e","725":"d1301399"}[chunkId] + ".js";
};